<template>
  <div>
    <v-toolbar flat color="red-darken-3" class="pt-1">
      <v-toolbar-title class="d-none d-md-flex ">{{ $t("home.home") }}</v-toolbar-title>
      <v-divider class="mx-5 hidden-md-and-down" inset vertical />
      <v-spacer />
      <v-btn
        color="grey-darken-4"
        variant="flat"
        class="ma-1"
        @click="openSearchDialog"
      >
        <v-icon start>mdi-qrcode</v-icon>
        {{ $t("home.search_part.label") }}
      </v-btn>
      <v-spacer v-if="$vuetify.display.xs" />
    </v-toolbar>
  </div>
</template>

<script>
export default {
  methods: {
    openSearchDialog() {
      this.$emit("search-dialog");
    },
  },
};
</script>
